import { TbMicrophone2, TbMicrophone2Off } from 'react-icons/tb';
import { API, useMode } from '@unboared/react';

import { Button } from '~/components/ui/button';

export function ModeButton() {
    const { mode } = useMode();

    return (
        <Button
            preset="secondary"
            icon={mode === 'anim' ? <TbMicrophone2 /> : <TbMicrophone2Off />}
            onClick={() => API.loadMode(mode === 'anim' ? 'auto' : 'anim')}
        />
    );
}
